import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { LanguageService } from '../../shared/services/language.service';
import { AccountService } from '../../shared/services/account.service';

declare var Swal:any

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

    constructor(
        public activatedRoute: ActivatedRoute,
        public router : Router,
        public language : LanguageService,
        public accountService : AccountService,
    ) { }

    public password = ''
    public validPassword = false
    public password2 = ''
    public token = null
    public loading = true

    ngOnInit(): void {
        this.activatedRoute.params.subscribe((params: Params) => {
            if(params["token"]){
                this.accountService.checkResetPasswordToken(params["token"])
                .then((res)=>{
                    if(res && res['success']){
                        this.token = params['token']
                        this.loading = false
                    }
                    else if(res && res['error'] && res['error'] == 'bad_token'){
                        Swal.fire(this.language.translate.instant('Erreur'), this.language.translate.instant('Ce lien est invalide ou périmé'), 'error')
                        .then(()=>{
                            this.router.navigate(this.language.navigateAccordingToLang(['/']))
                        })
                    }
                    else{
                        Swal.fire(this.language.translate.instant('Erreur'), this.language.translate.instant('Une erreur est survenue, veuillez réessayer'), 'error')
                        .then(()=>{
                            this.router.navigate(this.language.navigateAccordingToLang(['/']))
                        })
                    }
                })
            }
            else{
                this.router.navigate(this.language.navigateAccordingToLang(['/']))
            }
        });
    }

    proceed(){
        if(this.validPassword && this.password == this.password2){
            this.loading = true
            this.accountService.changePasswordWithToken(this.token, this.password)
            .then((res)=>{
                this.loading = false
                if(res && res['success']){
                    return Swal.fire('', this.language.translate.instant('Votre mot de passe a été modifié avec succès'), 'success')
                    .then(()=>{
                        this.router.navigate(this.language.navigateAccordingToLang(['/login']))
                    })
                }
                else if(res && res['error'] && res['error'] == 'bad_token'){
                    return Swal.fire(this.language.translate.instant('Erreur'), this.language.translate.instant('Ce lien est invalide ou périmé'), 'error')
                    .then(()=>{
                        this.router.navigate(this.language.navigateAccordingToLang(['/']))
                    })
                }
                else{
                    return Swal.fire(this.language.translate.instant('Erreur'), this.language.translate.instant('Une erreur est survenue, veuillez réessayer'), 'error')
                }
            })
        }


    }

}
